import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import React, { useState, useRef, useContext, useEffect } from 'react';
import {
  IoChevronDownOutline,
  IoChevronUpOutline,
  IoDownload
} from 'react-icons/io5';
import styles from './collapse.module.scss';
import '../../theme/global.scss';
import CButton from '../../components/button/button';
import { columnsAcquisitions } from '../../utils/tables';
import CTable from '../../components/table/table';
import 'antd/dist/antd.css';
import { Input, Form, Tooltip, InputRef } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { Space } from '../utils/utils';
import { variables } from '../../utils/variables';
import { updateTable, deleteRow, getTable } from '../../network/situatie';
import { ISituatie, ISituatieEntry } from '../../utils/interfaces/interfaces';
const EditableContext = React.createContext<FormInstance<any> | null>(null);

interface Item {
  key: string;
  name: string;
  age: string;
  address: string;
}

interface EditableRowProps {
  index: number;
}

const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

interface EditableCellProps {
  title: React.ReactNode;
  editable: boolean;
  children: React.ReactNode;
  dataIndex: keyof Item;
  record: Item;
  handleSave: (record: Item) => void;
}

const EditableCell: React.FC<EditableCellProps> = ({
  title,
  editable,
  children,
  dataIndex,
  record,
  handleSave,
  ...restProps
}) => {
  const [editing, setEditing] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const form = useContext(EditableContext)!;

  useEffect(() => {
    if (editing) {
      inputRef.current!.focus();
    }
  }, [editing]);

  const toggleEdit = () => {
    setEditing(!editing);
    form.setFieldsValue({ [dataIndex]: record[dataIndex] });
  };

  const validationRules = (title: React.ReactNode, dataIndex: keyof Item) => {
    console.log(dataIndex);

    if ((dataIndex as String) === 'codCPV') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar.`,
          pattern: new RegExp(/^[0-9\-]+$/)
        }
      ];
    }
    if ((dataIndex as String) === 'valoareEstimata') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar cu maxim doua zecimale.`,
          pattern: new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/)
        }
      ];
    }
    if ((dataIndex as String) === 'crediteBugetareAprobate') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar cu maxim doua zecimale.`,
          pattern: new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/)
        }
      ];
    }
    if ((dataIndex as String) === 'angajamentBugetar') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar.`,
          pattern: new RegExp(/^[0-9\-]+$/)
        }
      ];
    }
    if ((dataIndex as String) === 'dataAngajamentBugetar') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip data format ZZ/LL/AAAA`,
          pattern: new RegExp(/^(\d{2}([/])\d{2}([/])\d{4})|\-$/)
        }
      ];
    }
    if ((dataIndex as String) === 'valoareAngajamentBugetar') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar cu maxim doua zecimale.`,
          pattern: new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/)
        }
      ];
    }
    if ((dataIndex as String) === 'valoareOferta') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar cu maxim doua zecimale.`,
          pattern: new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/)
        }
      ];
    }
    if ((dataIndex as String) === 'punctajObtiut') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar.`,
          pattern: new RegExp(/^[0-9]+$/)
        }
      ];
    }
    if ((dataIndex as String) === 'valoareCastigatoare') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar cu maxim doua zecimale.`,
          pattern: new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/)
        }
      ];
    }
    if ((dataIndex as String) === 'angajamentLegal') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar.`,
          pattern: new RegExp(/^[0-9\-]+$/)
        }
      ];
    }
    if ((dataIndex as String) === 'dataAngajamentLegal') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip data format ZZ/LL/AAAA`,
          pattern: new RegExp(/^(\d{2}([/])\d{2}([/])\d{4})|\-$/)
        }
      ];
    }
    if ((dataIndex as String) === 'valoareAngajamentLegal') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar cu maxim doua zecimale.`,
          pattern: new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/)
        }
      ];
    }
    if ((dataIndex as String) === 'facturaData') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip data format ZZ/LL/AAAA`,
          pattern: new RegExp(/^(\d{2}([/])\d{2}([/])\d{4})|\-$/)
        }
      ];
    }
    if ((dataIndex as String) === 'ordonantarePlataNr') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar cu maxim doua zecimale.`,
          pattern: new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/)
        }
      ];
    }
    if ((dataIndex as String) === 'ordonantarePlataData') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip data format ZZ/LL/AAAA`,
          pattern: new RegExp(/^(\d{2}([/])\d{2}([/])\d{4})|\-$/)
        }
      ];
    }
    if ((dataIndex as String) === 'platiEfectuateValoare') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar.`,
          pattern: new RegExp(/^[0-9\-]+$/)
        }
      ];
    }
    if ((dataIndex as String) === 'angajamenteLegaleRamasePlata') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip numar cu maxim doua zecimale.`,
          pattern: new RegExp(/^[0-9]*(\.[0-9]{0,2})?$/)
        }
      ];
    }
    if ((dataIndex as String) === 'dataDataNotaIntrareReceptie') {
      return [
        {
          required: true,
          message: `${title} este un câmp obligatoriu de tip data.`,
          pattern: new RegExp(/^(\d{2}([./-])\d{2}([./-])\d{4})|\-$/)
        }
      ];
    }
    return [
      {
        required: true,
        message: `${title} este un câmp obligatoriu.`
      }
    ];
  };

  const save = async () => {
    try {
      const values = await form.validateFields();
      toggleEdit();
      handleSave({ ...record, ...values });
    } catch (errInfo) {
      console.log('Save failed:', errInfo);
    }
  };

  let childNode = children;

  if (editable) {
    childNode = editing ? (
      <Form.Item
        style={{ margin: 0 }}
        name={dataIndex}
        rules={validationRules(title, dataIndex)}
      >
        <Input ref={inputRef} onPressEnter={save} onBlur={save} />
      </Form.Item>
    ) : (
      <div
        className='editable-cell-value-wrap'
        style={{ paddingRight: 24 }}
        onClick={toggleEdit}
      >
        {children}
      </div>
    );
  }

  return <td {...restProps}>{childNode}</td>;
};
interface ITable {
  source: ISituatie;
  setSource?: any;
  updateSource: any;
  getTablesData: any;
}

const CCollapseTable = (props: ITable) => {
  const { source } = props;
  const [opened, setOpened] = useState(false);

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell
    }
  };

  const handleSwitch = () => {
    setOpened(op => !op);
  };

  const handleAdd = () => {
    const ids = source.entries.map(entry => entry.nrCrt);
    const maxId = Math.max(...ids);
    const newData = {
      nrCrt: maxId + 1,
      articolBugetar: '-',
      denumireAchizitie: '-',
      codCPV: '-',
      valoareEstimata: 0,
      crediteBugetareAprobate: 0,
      angajamentBugetar: '-',
      /**/
      dataAngajamentBugetar: '-',
      /**/
      valoareAngajamentBugetar: 0,
      proceduraDeAchizitie: '-',
      ofertanti: '-',
      criteriuEvaluareOferta: '-',
      valoareOferta: 0,
      punctajObtiut: 0,
      valoareCastigatoare: 0,
      angajamentLegal: '-',
      /**/
      dataAngajamentLegal: '-',
      /**/
      valoareAngajamentLegal: 0,
      facturaNr: '-',
      facturaData: '-',
      ordonantarePlataNr: '-',
      ordonantarePlataData: '-',
      platiEfectuateValoare: 0,
      angajamenteLegaleRamasePlata: 0,
      nrDataNotaIntrareReceptie: '-',
      /**/
      dataDataNotaIntrareReceptie: '-',
      /**/
      observatii: '-'
    };

    props.updateSource(source.year, {
      year: source.year,
      entries: source.entries.concat([newData])
    });
  };

  const handleDeleteRow = (row: any) => {
    deleteRow(props.source.year, row.id).then(() => {
      getTable(props.source.year).then(({ data }) => {
        data = data.data[0];
        props.updateSource(data.year, {
          year: data.year,
          entries: data.entries.map((entry: any) => ({
            ...entry,
            angajamentBugetar: entry.angajamentBugetar.split('#')[0] || '-',
            dataAngajamentBugetar: entry.angajamentBugetar.split('#')[1] || '-',
            angajamentLegal: entry.angajamentLegal.split('#')[0] || '-',
            dataAngajamentLegal: entry.angajamentLegal.split('#')[1] || '-',
            facturaNr:
              (entry.facturaNrData && entry.facturaNrData.split('#')[0]) || '-',
            facturaData:
              (entry.facturaNrData && entry.facturaNrData.split('#')[1]) || '-',
            ordonantarePlataNr:
              (entry.ordonantarePlata &&
                entry.ordonantarePlata.split('#')[0]) ||
              '-',
            ordonantarePlataData:
              (entry.ordonantarePlata &&
                entry.ordonantarePlata.split('#')[1]) ||
              '-',
            nrDataNotaIntrareReceptie:
              entry.nrDataNotaIntrareReceptie.split('#')[0] || '-',
            dataDataNotaIntrareReceptie:
              entry.nrDataNotaIntrareReceptie.split('#')[1] || '-'
          }))
        });
      });
    });
  };

  const columns = columnsAcquisitions(handleDeleteRow).map(col => {
    if (!col.editable) {
      return col;
    }

    return {
      ...col,
      onCell: (record: any) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave: (updateValue: any) => {
          props.updateSource(source.year, {
            year: source.year,
            entries: source.entries.map(entry =>
              entry.nrCrt === updateValue.nrCrt ? updateValue : entry
            )
          });
        }
      })
    };
  });

  const downloadExcel = () => {
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const fileName = `Situație achiziții ${props.source.year}`;

    const convertedKeys =
      props.source.entries &&
      props.source.entries.map((entry: ISituatieEntry) => ({
        'Nr. Crt.': entry.nrCrt,
        'Articol bugetar': entry.articolBugetar,
        'Denumire achizitie': entry.denumireAchizitie,
        'Cod CPV': entry.codCPV,
        'Valoare estimată\n(Lei fără TVA)': entry.valoareEstimata,
        'Credite bugetare\naprobate (Lei)': entry.crediteBugetareAprobate,
        'Nr. angajament\nbugetar': entry.angajamentBugetar,
        'Dată angajament\nbugetar': entry.dataAngajamentBugetar,
        'Valoare angajament\nbugetar (Lei cu TVA)':
          entry.valoareAngajamentBugetar,
        'Procedura de\nachiziție': entry.proceduraDeAchizitie,
        'Ofertanți (Denumire firmă)': entry.ofertanti,
        'Criteriu de evaluare a ofertelor': entry.criteriuEvaluareOferta,
        'Valoare ofertă\n(Lei fără TVA)': entry.valoareOferta,
        'Punctaj\nobținut': entry.punctajObtiut,
        'Valoare desemnată\ncâștigătoare\n(Lei cu TVA)':
          entry.valoareCastigatoare,
        'Nr. angajament\nlegal': entry.angajamentLegal,
        'Valoare angajament\nlegal\n(Lei cu TVA)': entry.valoareAngajamentLegal,
        'Nr. factură': entry.facturaNr,
        'Dată factură': entry.facturaData,
        'Nr. ordonanțare\nla plată': entry.ordonantarePlataNr,
        'Dată ordonanțare\nla plată': entry.ordonantarePlataData,
        'Plăți efectuate (Lei)': entry.platiEfectuateValoare,
        'Angajamente legale\nrămase de plată (Lei)':
          entry.angajamenteLegaleRamasePlata,
        'Nr. notei de intrare\nrecepție/procesului\nverbal de recepție':
          entry.nrDataNotaIntrareReceptie,
        'Data notei de intrare\nrecepție/procesului\nverbal de recepție':
          entry.dataDataNotaIntrareReceptie,
        Observații: entry.observatii
      }));

    var wscols = [
      { width: 9 },
      { width: 10 },
      { width: 18 },
      { width: 18 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 14 },
      { width: 9 },
      { width: 18 },
      { width: 14 },
      { width: 20 },
      { width: 14 },
      { width: 14 },
      { width: 16 },
      { width: 16 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 10 }
    ];

    //const ws = XLSX.utils.json_to_sheet(convertedKeys);
    //ws['!cols'] = wscols;

    var ws_data = [
      [
        {
          v: `Situație privind achizițiile publice in anul ${props.source.year}`,
          t: 's',
          bold: true,
          alignRight: true
        }
      ]
    ];
    var ws = XLSX.utils.aoa_to_sheet(ws_data);

    XLSX.utils.sheet_add_json(ws, convertedKeys, {
      skipHeader: false,
      origin: 'A3'
    });

    ws['!cols'] = wscols;
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  return (
    <div className={styles.card} id={source.year}>
      <Tooltip title={'Descărcați în format Excel'}>
        <CButton
          className={styles.addFollowUp}
          label={<IoDownload />}
          onClick={downloadExcel}
          type='button'
        />
      </Tooltip>

      <div className={styles.text} onClick={handleSwitch}>
        <p className='body-dark bold'>Situația pe {source.year}</p>
        <button className={styles.switch}>
          Detalii
          {opened ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
        </button>
      </div>
      {opened && (
        <div className={styles.details}>
          <CButton label='Adaugă rând' onClick={handleAdd} type='button' />
          <Space vertical={variables.verticalSpace} />
          <p className='small-dark bold info'>
            Selectați o celulă pentru a edita.
          </p>
          <div className={styles.tableContainer}>
            <CTable
              data={source.entries}
              columns={columns}
              components={components}
              rowClassName={() => 'editable-row'}
            />
          </div>
          <CButton
            label={'Actualizează tabelul'}
            onClick={async () => {
              await updateTable(props.source, props.source.year);
              props.getTablesData();
            }}
            type='button'
          />
        </div>
      )}
    </div>
  );
};

export default CCollapseTable;
